<template>
    <div class="box">
        <div class="box-header">
            <div class="box-toggle" data-toggle="collapse" href="#collapseExample1" role="button" aria-expanded="true" aria-controls="collapseExample1">
                دسته بندی محصولات
                <i class="now-ui-icons arrows-1_minimal-down"></i>
            </div>
        </div>
        <div class="box-content">
            <div class="collapse show" id="collapseExample1">
                <div class="filter-option">
                    <ul class="groupvalue">
                        <li v-for="group in groups">
                            <i class="now-ui-icons arrows-1_minimal-left"></i><a :title="group.Title"class="group-product" @click="redirectToGroup(group.Id , group.Title)">{{group.Title}}</a>
                            <ul class="subGroup-product">
                                <li class="subgroupvlaue" v-for="subGroup in group.SubGroups">
                                    <a :title="subGroup.Title" class="tag-a" @click="redirectToSubGroup(subGroup.Id , subGroup.Title)">
                                    <i class="now-ui-icons arrows-1_minimal-down"></i> {{subGroup.Title}}</a>
                                <ul class="category-ul">
                                    <li class="category-li" v-for="category in subGroup.Categories">
                                        <a :title="category.Title" @click="redirectToCategory(category.Id , category.Title,subGroup.Id,subGroup.Title)" class="category-tag">{{category.Title}}</a>
                                    </li>
                                </ul>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            groups: function () {
                return this.$store.getters.readGroups;
            }
        },
        methods: {
            redirectToGroup(id, name) {
                this.$router.push({ name: 'filter', query: { GroupId: id, GroupName: name } });
            },
            redirectToSubGroup(id, name) {
                this.$router.push({ name: 'filter', query: { SubGroupId: id, SubGroupName: name } });
            },
            redirectToCategory(id, name, subGroupId, subGroupName) {
                this.$router.push({ name: 'filter', query: { CategoryId: id, CategoryName: name, SubGroupId: subGroupId, SubGroupName: subGroupName } });
            }
        }
    }
</script>

<style scoped>
    .box-content .filter-option ul .subgroupvlaue {
        font-size: 14px;
    }

    #collapseExample1 {
        max-height: 300px;
        overflow-y: auto;
    }
    ul li a {
        cursor: pointer;
    }

    .box-content .filter-option .groupvalue .group-product {
        font-size: 12px;
        display: inline-block;
    }

    .filter-option i {
        padding-left:1px;
        font-size: 8px;
        vertical-align: middle;
    }

    .filter-option .group-product {
        color: #000 !important;
        transition: all .3s;
        font-weight: bold;
    }

        .filter-option .group-product:hover {
            color: #c6c6c6 !important;
            transition: all .3s;
        }

    .filter-option .subGroup-product {
        padding-right: 30px;
        display: block;
    }
        .filter-option .subGroup-product .category-ul {
            padding-right:35px;
        }
        .filter-option .subGroup-product li {
            display: block;
            padding:2px;
            color: #666 !important;
            transition: all .3s;
        }
    .category-ul .category-li .category-tag {
        font-size:12px;
    }
    .subgroupvlaue .tag-a {
        color: #555;
        font-weight: bold;
        font-size: 12px;
    }
    /*.groupvalue > li {
        margin-bottom:10px;
    }*/
    .filter-content ul li {
        display: inline-block;
        padding: 5px;
        margin: 5px 3px 5px 3px;
        background-color: #f5f5f5;
        border-radius: 5px;
        font-size: 12px;
        font-weight: bold;
        color: #666;
    }

    .box-content .filter-option ul .subgroupvlaue {
        font-size: 14px;
    }
</style>